module.exports = __webpack_public_path__ + "img/FiberAPI-logo-grey.0e3b36bc.svg";